import styled from "@emotion/styled";
import { Text } from "@otrium/atoms";

const StyledText = styled(Text)`
  font-size: 16px;
  letter-spacing: 0.4px;
  color: white;
`;

export { StyledText };
